import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {map} from 'rxjs/operators';
import {Observable} from 'rxjs';
import {AppSettings} from '../../proyect.conf';

@Injectable({
  providedIn: 'root'
})
export class SimuladorConfiguracionService {

  private rutServicio = AppSettings.rutServiciosAPL + '/api/simuladorConfiguracion/';

  constructor(private httpClient: HttpClient) {}

  actualizarInformacion(): Observable<any> {
    return this.httpClient.get(this.rutServicio + 'actualizar-cache').pipe(map(res => res as any));
  }

}
